import React, { useEffect, useRef, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import get from 'lodash/get';
import uniqueId from 'lodash/uniqueId';

import env from 'Env';
import PaymentContext from 'Components/Payment/payment-context';
import CheckoutUtils from 'Helpers/Checkout/CheckoutUtils';
import { countryCode } from 'Helpers/Geo/data';

const GooglePayPayment = ({ method, isOpen, siteTheme }) => {
  const paymentContext = useContext(PaymentContext);
  const {
    order,
    setError,
    checkout,
    isSubscription,
    isNewSavedMethod,
  } = paymentContext;
  const googlepayRef = useRef(null);
  const oneClickOption = get(method, 'configuration.oneClickOption');

  const [enableOneClick, setEnableOneClick] = useState(false);

  const toggleEnableOneClick = () => setEnableOneClick(!enableOneClick);

  const key = uniqueId();

  useEffect(() => {
    if (isOpen) {
      let buttonType = 'pay';

      if (isSubscription) {
        buttonType = 'subscribe';
      }

      if (isNewSavedMethod) {
        buttonType = 'plain';
      }

      const googlepay = checkout.create('paywithgoogle', {
        configuration: method.configuration,
        countryCode,
        environment: env.adyenApiContext,
        amount: {
          currency: order.report.currencyCode,
          value: order.payment.total,
        },
        buttonType,
        buttonColor: siteTheme === 'dark' ? 'white' : 'black',
        buttonLocale: window.locale || 'en',
        onChange: async (state, component) => {
          if (!state.isValid) {
            return setError('PGP000');
          }

          return CheckoutUtils.submitPayment(paymentContext, setError, 'paywithgoogle', state.data.paymentMethod, component, undefined, enableOneClick);
        },
      });
      googlepay.isAvailable()
        .then(() => {
          googlepay.mount(googlepayRef.current);
        })
        .catch(() => setError('PGP003'));
    }
  }, [
    isOpen,
    order,
    setError,
    method,
    checkout,
    siteTheme,
    isSubscription,
    isNewSavedMethod,
    enableOneClick,
    paymentContext,
  ]);

  return (
    <div className="payment-option-collapse">
      <div>
        <FormattedMessage
          id="googlepay-payment.instruction"
          defaultMessage="Click the button to authenticate GooglePay and complete your payment securely"
        />
      </div>
      {(oneClickOption || isSubscription) && !isNewSavedMethod &&
        <div className="remember-tick-container mt-2">
          <label htmlFor={`rememeber-${key}`}>
            <input disabled={isSubscription} type="checkbox" id={`rememeber-${key}`} name={`rememeber-${key}`} defaultChecked={isSubscription ? true : enableOneClick} onChange={() => toggleEnableOneClick()} />
            <FormattedMessage
              id="google-payment.remember-tickbox"
              defaultMessage="Save this googlepay card"
            />
          </label>
        </div>
      }
      <div className="complete-button-container">
        <div className="googlepay-checkout-btn" ref={googlepayRef} />
      </div>
    </div>
  );
};

GooglePayPayment.propTypes = {
  method: PropTypes.shape({}).isRequired,
  isOpen: PropTypes.bool,
  siteTheme: PropTypes.string,
};

GooglePayPayment.defaultProps = {
  isOpen: false,
  siteTheme: 'dark',
};

const mapStateToProps = ({ siteTheme }) => ({ siteTheme });

export default connect(mapStateToProps)(GooglePayPayment);
